import SurveyRepository from "@/js/repositories/SurveyRepository"

const state = {
    survey_id: null,
    banner_redirect_url: '',
    survey_thank_page_url: null,
    banner_image_url: '',
    survey_start_date: '',
    survey_end_date: '',
    errorMsg: '',
    surveyComplete: false
}

const getters = {
}

const actions = {
  async getSurvey({ commit }) {
    await SurveyRepository.getSurvey()
        .then(response => {
            const survey = response.data.data
            if (survey) {
              commit('SET_SURVEY_ID', survey.survey_id)
              commit('SET_BANNER_REDIRECT_URL', survey.banner_redirect_url)
              commit('SET_SURVEY_THANK_PAGE_URL', survey.survey_thank_page_url)
              commit('SET_BANNER_IMAGE_URL', survey.banner_image_url)
              commit('SET_SURVEY_START_DATE', survey.survey_start_date)
              commit('SET_SURVEY_END_DATE', survey.survey_end_date)
              commit('SET_SURVEY_COMPLETE', false)
            }
            else {
              commit('RESET_SURVEY')
            }
        })
        .catch( error => {
            console.log("error: ", error)
        })
  },
  async completeSurvey ({ commit }, data) {
    await SurveyRepository.completeSurvey(data)
      .then(resp => {
        commit('RESET_SURVEY')
      })
      .catch(error => {
        let errMsg = i18n.t('api_has_occurred_with_status', {status: error.response.status})
        commit('SET_MESSAGE_ERROR', errMsg)
      })
  }
};

const mutations = {
  RESET_SURVEY(state) {
    state.survey_id = null,
    state.banner_redirect_url = '',
    state.survey_thank_page_url = null,
    state.banner_image_url = '',
    state.survey_start_date = '',
    state.survey_end_date = '',
    state.errorMsg = '',
    state.surveyComplete = true
  },
  SET_SURVEY_ID(state, data) {
    state.survey_id = data ? data : null
  },
  SET_BANNER_REDIRECT_URL(state, data) {
    state.banner_redirect_url = data ? data : null
  },
  SET_SURVEY_THANK_PAGE_URL(state, data) {
    state.survey_thank_page_url = data ? data : null
  },
  SET_BANNER_IMAGE_URL(state, data) {
    state.banner_image_url = data ? data : null
  },
  SET_SURVEY_START_DATE(state, data) {
    state.survey_start_date = data ? data : null
  },
  SET_SURVEY_END_DATE(state, data) {
    state.survey_end_date = data ? data : null
  },
  SET_MESSAGE_ERROR (state, errMsg) {
    state.errorMsg = errMsg
  },
  SET_SURVEY_COMPLETE (state, value) {
    state.surveyComplete = value
  }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
